import Immutable from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import { COMMUNITY_DATA_KEY, JOIN_GROUP_STATUS, EVENT_TYPE } from '../constants/constants';
import { default as newFeed, default as TYPE } from '../constants/newFeed';
import initialState from './initialState';

export default function newFeedReducer(state = initialState.newFeedState, action) {
  switch (action.type) {
    case types.UPDATE_NEW_FEED_STATE: {
      state = state.setIn([...action.dataKey], action.data);
      return state;
    }
    case types.GET_DATA_HOME_PAGE_SUCCESS: {
      const { dataNewFeed, dataPinnedContent } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingNewFeed: false,
        isLoadMore: false,
        dataNewFeed: action.params.loadMore ? [...dataNewFeed, ...action.data] : action.data,
        dataPinnedContent: action.params.loadMore ? [...dataPinnedContent, ...action.dataPinnedContent] : action.dataPinnedContent,
        dataDateFinder: action.dataDateFinder,
        isHasMoreNewFeed: !(action.data instanceof Array && action.data.length < 24),
        error: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
      };
      if (!action.params.loadMore) {
        updateParams.timeToReset = new Date();
      }
      return state.merge({ ...updateParams });
    }
    case types.RESET_HOME_ERROR_STATUS: {
      return state.merge({
        error: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
      });
    }

    case types.MERGE_DATA_HOME_PAGE_SUCCESS: {
      return state.merge({ ...action.data });
    }
    case types.GET_ACTIVITY_SUMARY_USERS_SUCCESS: {
      return state.set(['isLoadingActivitySumaryUsers'], false).set(['activitySumaryUsers'], action.data);
    }
    case types.GET_DATA_HOME_PAGE_ERROR: {
      const { timeRetry } = state.error;
      const updateParams = {
        isLoadingNewFeed: false,
        isLoadingActivitySumaryUsers: false,
        isLoadingRecent: false,
        error: {
          isError: true,
          message: action.message,
          timeRetry: timeRetry + 1,
          isShowNoConnection: timeRetry >= 7,
        },
      };
      return state.merge({ ...updateParams });
    }
    case types.USER_LOGOUT_SUCCESS: {
      return initialState.newFeedState;
      // console.log("log out membersearchreducer")
    }
    case types.POST_CREATE_EVENT_INTEREST_SUCCESS:
    case types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS: {
      const { dataNewFeed, dataPinnedContent } = Immutable.asMutable(state);
      const { from, id, isUnInterest, type } = action.params;
      let interestCount = 1;
      if (action.type === types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS) {
        interestCount = -1;
      }
      if (from === 'homeScreen' || type === EVENT_TYPE.GROUP_POST_EVENT) {
        let dataMerge = {};
        const indexsOfGroup = [];
        const indexsOfGroupPin = [];
        let newActivity = dataNewFeed;
        let newPin = dataPinnedContent;

        newActivity = newActivity.map((item, index) => {
          if (item.typeId === TYPE.ClubPost) {
            if (Number(item.contentItem?.event?.[0].eventId) === Number(id)) {
              indexsOfGroup.push(index);
              return {
                ...item,
                contentItem: {
                  ...item.contentItem,
                  event: [
                    {
                      ...item.contentItem.event[0],
                      hasExpressInterest: !isUnInterest,
                      interestCount: item.contentItem.event[0].interestCount + interestCount,
                    },
                  ],
                },
              };
            }
          }
          if (
            item.typeId === TYPE.EventInterestAdd ||
            item.typeId === TYPE.COMMENT.EventComment ||
            item.typeId === TYPE.COMMENT_REPLY.EventCommentReply ||
            item.typeId === TYPE.CommentLike ||
            item.typeId === TYPE.ReplyLike ||
            item.typeId === TYPE.ADDED.EventAdd
          ) {
            if (Number(item.contentItem?.id) === Number(id)) {
              indexsOfGroup.push(index);
              return {
                ...item,
                contentItem: {
                  ...item.contentItem,
                  hasExpressInterest: !isUnInterest,
                  interestCount: item.contentItem.interestCount + interestCount,
                },
              };
            }
          }
          return item;
        });

        newPin = newPin.map((item, index) => {
          if (item.typeId === TYPE.ClubPost) {
            if (Number(item.contentItem?.event?.[0].eventId) === Number(id)) {
              indexsOfGroupPin.push(index);
              return {
                ...item,
                contentItem: {
                  ...item.contentItem,
                  event: [
                    {
                      ...item.contentItem.event[0],
                      hasExpressInterest: !isUnInterest,
                      interestCount: item.contentItem.event[0].interestCount + interestCount,
                    },
                  ],
                },
              };
            }
          }
          if (
            item.typeId === TYPE.EventInterestAdd ||
            item.typeId === TYPE.COMMENT.EventComment ||
            item.typeId === TYPE.COMMENT_REPLY.EventCommentReply ||
            item.typeId === TYPE.CommentLike ||
            item.typeId === TYPE.ReplyLike ||
            item.typeId === TYPE.ADDED.EventAdd
          ) {
            if (Number(item.contentItem?.id) === Number(id)) {
              indexsOfGroupPin.push(index);
              return {
                ...item,
                contentItem: {
                  ...item.contentItem,
                  hasExpressInterest: !isUnInterest,
                  interestCount: item.contentItem.interestCount + interestCount,
                },
              };
            }
          }
          return item;
        });

        if (indexsOfGroup.length > 0) {
          dataMerge.dataNewFeed = newActivity;
        }
        if (indexsOfGroupPin.length > 0) {
          dataMerge.dataPinnedContent = newPin;
        }

        state = state.merge(dataMerge);
      }

      return state;
    }
    case types.GET_RECENT_SUCCESS: {
      const updateParams = {
        isLoadingRecent: false,
        recentUsers: action.data,
      };

      return state.merge({ ...updateParams });
    }
    case types.GET_ANNOUNCEMENT_BANNER_SUCCESS: {
      if (action?.data?.announcementType !== state?.announcementBanner?.announcementType) {
        state = state.set(['announcementBanner'], action.data);
      }
      if (action?.data2?.announcementType !== state?.announcementBannerDesktop?.announcementType) {
        state = state.set(['announcementBannerDesktop'], action.data2);
      }
      return state;
    }

    case types.TOGGLE_TESTIMONIAL_MODAL: {
      const updateState = {
        isShowModal: false,
        data: null,
      };
      if (action.toggle && action.data) {
        updateState.isShowModal = true;
        updateState.data = action.data;
      }

      return state.merge({ testimonialsItem: { ...updateState } });
    }
    case types.POST_CREATE_FORUM_TOPIC_UNLIKE_SUCCESS:
    case types.POST_CREATE_FORUM_TOPIC_LIKE_SUCCESS:
    case types.POST_CREATE_LIKE_COMMUNITY_SUCCESS:
    case types.POST_CREATE_UN_LIKE_COMMUNITY_SUCCESS: {
      let id,
        likeCount,
        dataKey,
        parentId,
        parentLikeCount,
        parentIsLiked = null;
      let typeName = newFeed.OTG_NAME.OTG_Forum;
      if (action.params) {
        id = action.params.id;
        likeCount = action.params.likeCount;
        dataKey = action.params.dataKey;
      } else {
        id = action.id;
        likeCount = action.likeCount;
        dataKey = action.dataKey;
      }

      switch (action.dataKey) {
        case COMMUNITY_DATA_KEY.ARTICLE: {
          typeName = newFeed.OTG_NAME.OTG_Article;
          break;
        }
        case COMMUNITY_DATA_KEY.OTG_PHOTO: {
          parentId = action.parentId;
          parentLikeCount = action.parentLikeCount;
          parentIsLiked = action.parentIsLiked;
          typeName = newFeed.OTG_NAME.OTG_Photo;
          break;
        }
        case COMMUNITY_DATA_KEY.OTG: {
          parentId = action.parentId;
          parentLikeCount = action.parentLikeCount;
          parentIsLiked = action.parentIsLiked;
          typeName = newFeed.OTG_NAME.OTG_Gallery;
          break;
        }
        case COMMUNITY_DATA_KEY.STORIES: {
          typeName = newFeed.OTG_NAME.OTG_Story;
          break;
        }
        case COMMUNITY_DATA_KEY.OTG_PHOTO: {
          typeName = newFeed.OTG_NAME.OTG_Photo;
          break;
        }
        case COMMUNITY_DATA_KEY.OTG_VIDEO: {
          typeName = newFeed.OTG_NAME.OTG_Video;
          break;
        }
      }
      const { dataNewFeed, dataPinnedContent } = Immutable.asMutable(state);
      state = updateLikeForItem(state, { data: dataNewFeed, id: parentId || id, typeName, likeCount: parentLikeCount || likeCount, parentIsLiked, dataName: 'dataNewFeed' });
      state = updateLikeForItem(state, {
        data: dataPinnedContent,
        id: parentId || id,
        typeName,
        likeCount: parentLikeCount || likeCount,
        parentIsLiked,
        dataName: 'dataPinnedContent',
      });
      return state;
    }
    case types.UPDATE_MEDIA_LIKE_SUCCESS: {
      const { dataNewFeed, dataPinnedContent } = Immutable.asMutable(state);
      const { data } = action;
      let item;
      let realIndexInData = dataNewFeed.findIndex(item => item.contentItem.id?.toString() === data.id.toString() && item.typeName === data.typeName);
      let realIndexInDataPinnedContent = dataPinnedContent.findIndex(item => item.contentItem.id.toString() === data.id.toString() && item.typeName === data.typeName);
      if (dataPinnedContent[realIndexInDataPinnedContent]?.contentItem?.id.toString() === data.id.toString()) {
        item = JSON.parse(JSON.stringify(dataPinnedContent[realIndexInDataPinnedContent]));
      }
      if (dataNewFeed[realIndexInData]?.contentItem?.id.toString() === data.id.toString()) {
        item = JSON.parse(JSON.stringify(dataNewFeed[realIndexInData]));
      }
      if (item) {
        let likeCount = item.contentItem.likeCount !== -1 && item.contentItem.likeCount !== null && item.contentItem.likeCount !== undefined ? item.contentItem.likeCount : 0;
        if (data.isLiked) {
          likeCount = likeCount - 1;
        } else {
          likeCount = likeCount + 1;
        }
        item.contentItem.isMemberLike = !data.isLiked;
        item.contentItem.likeCount = likeCount;
      }

      if (realIndexInData !== -1) {
        state = state.setIn(['dataNewFeed', realIndexInData], item);
      }
      if (realIndexInDataPinnedContent !== -1) {
        state = state.setIn(['dataPinnedContent', realIndexInDataPinnedContent], item);
      }

      return state;
    }
    case types.UPDATE_POST_LIKE_SUCCESS: {
      const { dataNewFeed, dataPinnedContent } = Immutable.asMutable(state);
      const { params } = action;
      let item;
      let realIndexInData = dataNewFeed.findIndex(item => item.contentItem.id === params.id && item.typeName === params.typeName);
      let realIndexInDataPinnedContent = dataPinnedContent.findIndex(item => item.contentItem.id === params.id && item.typeName === params.typeName);

      if (dataPinnedContent[realIndexInDataPinnedContent]?.contentItem?.id === params.id) {
        item = JSON.parse(JSON.stringify(dataPinnedContent[realIndexInDataPinnedContent]));
      }
      if (dataNewFeed[realIndexInData]?.contentItem?.id === params.id) {
        item = JSON.parse(JSON.stringify(dataNewFeed[realIndexInData]));
      }
      if (item) {
        let likeCount = item.contentItem.likeCount !== -1 && item.contentItem.likeCount !== null && item.contentItem.likeCount !== undefined ? item.contentItem.likeCount : 0;
        if (params.isLiked) {
          likeCount = likeCount - 1;
        } else {
          likeCount = likeCount + 1;
        }
        item.contentItem.isMemberLike = !params.isLiked;
        item.contentItem.likeCount = likeCount;
      }
      if (realIndexInData !== -1) {
        state = state.setIn(['dataNewFeed', realIndexInData], item);
      }
      if (realIndexInDataPinnedContent !== -1) {
        state = state.setIn(['dataPinnedContent', realIndexInDataPinnedContent], item);
      }
      return state;
    }
    case types.JOIN_A_GROUP_SUCCESS: {
      const { dataNewFeed, dataPinnedContent, dataPopularGroups } = Immutable.asMutable(state);
      const { clubId, isInvited, status } = action.data;
      if (dataPopularGroups?.length > 0) {
        const grIndex = dataPopularGroups.findIndex(gr => gr.clubID?.toString() === clubId?.toString());
        if (grIndex !== -1) {
          state = state.setIn(['dataPopularGroups', grIndex], {
            ...dataPopularGroups[grIndex],
            joinSettings: {
              ...dataPopularGroups[grIndex].joinSettings,
              joinStatus: status || JOIN_GROUP_STATUS.PENDING,
            },
          });
        }
      }
      state = updateStatusOfGroupData(state, {
        data: dataNewFeed,
        clubId,
        fieldName: ['dataNewFeed'],
        joinStatus: status || (isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING),
      });
      state = updateStatusOfGroupData(state, {
        data: dataPinnedContent,
        clubId,
        fieldName: ['dataPinnedContent'],
        joinStatus: status || (isInvited ? JOIN_GROUP_STATUS.APPROVED : JOIN_GROUP_STATUS.PENDING),
      });
      return state;
    }
    case types.LEAVE_A_GROUP_SUCCESS: {
      const { dataNewFeed, dataPinnedContent, dataPopularGroups } = Immutable.asMutable(state);
      const { clubId } = action.data;
      if (dataPopularGroups?.length > 0) {
        const grIndex = dataPopularGroups.findIndex(gr => gr.clubID?.toString() === clubId?.toString());
        if (grIndex !== -1) {
          state = state.setIn(['dataPopularGroups', grIndex], {
            ...dataPopularGroups[grIndex],
            joinSettings: {
              ...dataPopularGroups[grIndex].joinSettings,
              joinStatus: JOIN_GROUP_STATUS.NOTJOINED,
            },
          });
        }
      }
      state = updateStatusOfGroupData(state, { data: dataNewFeed, clubId, fieldName: ['dataNewFeed'], joinStatus: JOIN_GROUP_STATUS.NOTJOINED });
      state = updateStatusOfGroupData(state, { data: dataPinnedContent, clubId, fieldName: ['dataPinnedContent'], joinStatus: JOIN_GROUP_STATUS.NOTJOINED });
      return state;
    }

    default:
      return state;
  }
}

function updateLikeForItem(state, { data = [], id, typeName, likeCount, dataName = '', parentIsLiked = null }) {
  const lsEx = [];
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (item.typeName === typeName && item.contentItem.id.toString() === id.toString()) {
      lsEx.push(i);
    }
  }
  if (lsEx.length > 0) {
    for (let idxEx of lsEx) {
      const itmEx = data[idxEx];
      state = state.setIn([dataName, idxEx, 'contentItem'], {
        ...itmEx.contentItem,
        likeCount: parentIsLiked !== null ? (parentIsLiked ? likeCount : likeCount + 1) : itmEx.contentItem.isMemberLike ? likeCount - 1 : likeCount + 1,
        isMemberLike: parentIsLiked !== null ? true : !itmEx.contentItem.isMemberLike,
      });
    }
  }

  return state;
}

export function updateStatusOfGroupData(state, { data, clubId, fieldName, joinStatus }) {
  const realIndexsInData = [];
  data.forEach((item, index) => {
    if (item.contentItem.clubID?.toString() === clubId?.toString() && (item.typeName === TYPE.Club || item.typeName === TYPE.ClubJoin)) {
      realIndexsInData.push(index);
    }
  });
  if (realIndexsInData.length > 0) {
    for (let i = 0; i < realIndexsInData.length; i++) {
      const index = realIndexsInData[i];
      state = state.setIn([...fieldName, index, 'contentItem', 'joinSettings', 'joinStatus'], joinStatus);
    }
  }
  return state;
}
